export default "__VITE_ASSET__10bd7578__"